import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/user.service';
import { Router } from '@angular/router';
import { LoginService } from '../security/login.service';
import { environment } from 'src/environments/environment';
import { MenuItem } from 'primeng/api';
import { HttpService } from '../service/http.service';
import { KeycloakAuthService } from '../security/keycloak-auth.service';


@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

  constructor(
    public userService: UserService,
    private router: Router,
    private loginService: LoginService,
    private httpService: HttpService,
    private keycloakService: KeycloakAuthService
  ) {
    this.customMenuItems = [];
    httpService.getCustomLinks().subscribe(res => {
      for(let customItem of res){
        this.customMenuItems.push({label: customItem.name, routerLink: customItem.link});
      }
    });
   }

  userName: string | undefined;
  items: MenuItem[] = [];
  sbmsVersion: string = environment.sbmsVersion;
  customMenuItems: MenuItem[] = [{label: "Lalala", routerLink: "management/leads"}];

  ngOnInit() { 
    this.items = [
      { label: "Config", icon: 'pi pi-fw pi-cog', routerLink: "management/user-config" }
  ];
  }

  logout(){
    this.httpService.logout().subscribe(() => {
      this.keycloakService.logout();
      localStorage.removeItem("isConnected");
      document.cookie = "XSRF-TOKEN=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      this.router.navigate(["/post-logout"]);
    });
  }

  navigate(){
    this.router.navigateByUrl("/links");
  }

}
